import { render, staticRenderFns } from "./addressInfo.vue?vue&type=template&id=322147de&scoped=true"
import script from "./addressInfo.vue?vue&type=script&lang=js"
export * from "./addressInfo.vue?vue&type=script&lang=js"
import style0 from "./addressInfo.vue?vue&type=style&index=0&id=322147de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322147de",
  null
  
)

export default component.exports